/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Empty1Inputs */

const zh_admincredit_empty1 = /** @type {(inputs: Admincredit_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无用户记录`)
};

const en_admincredit_empty1 = /** @type {(inputs: Admincredit_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found`)
};

const es_admincredit_empty1 = /** @type {(inputs: Admincredit_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay usuarios`)
};

/**
* | output |
* | --- |
* | "No users found" |
*
* @param {Admincredit_Empty1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_empty1 = /** @type {((inputs?: Admincredit_Empty1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Empty1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_empty1(inputs)
	if (locale === "en") return en_admincredit_empty1(inputs)
	return es_admincredit_empty1(inputs)
});
export { admincredit_empty1 as "adminCredit_empty" }